var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHouse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43AF49",
    fillRule: "evenodd",
    d: "M6.4 14.8L6.4 10 9.6 10 9.6 14.8 13.6 14.8 13.6 8.4 16 8.4 8 1.2 0 8.4 2.4 8.4 2.4 14.8z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHouse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/house.1fccf4ee.svg";
export { ForwardRef as ReactComponent };